import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { ProtectedRoute } from '@/router/ProtectedRoute'

export const frameworkRoutes: RouteObject[] = [
  {
    path: 'frameworks',
    lazy: async () => {
      const module = await import('@/features/admin/framework/layouts/FrameworkLayout')
      return {
        element: <module.FrameworkLayout />
      }
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const module = await import('@/features/admin/framework/pages/FrameworkVersionListPage')
          return {
            element: <module.FrameworkVersionListPage />
          }
        }
      },
      {
        path: 'functions',
        children: [
          {
            index: true,
            lazy: async () => {
              const module = await import('@/features/admin/framework/pages/FunctionListPage')
              return {
                element: <module.FunctionListPage />
              }
            }
          },
          {
            path: ':codigo',
            lazy: async () => {
              const module = await import('@/features/admin/framework/pages/FunctionPage')
              return {
                element: <module.FunctionPage />
              }
            }
          },
          {
            path: ':codigo/edit',
            element: (
              <ProtectedRoute
                requiredRoles={['Gerente', 'Administrador']}
                unauthorizedComponent={<Navigate to="/admin/frameworks/functions" replace />}
              />
            ),
            children: [
              {
                index: true,
                lazy: async () => {
                  const module = await import('@/features/admin/framework/pages/FunctionPage')
                  return {
                    element: <module.FunctionPage />
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: 'categories',
        children: [
          {
            index: true,
            lazy: async () => {
              const module = await import('@/features/admin/framework/pages/CategoryListPage')
              return {
                element: <module.CategoryListPage />
              }
            }
          },
          {
            path: ':codigo',
            lazy: async () => {
              const module = await import('@/features/admin/framework/pages/CategoryPage')
              return {
                element: <module.CategoryPage />
              }
            }
          },
          {
            path: ':codigo/edit',
            element: (
              <ProtectedRoute
                requiredRoles={['Gerente', 'Administrador']}
                unauthorizedComponent={<Navigate to="/admin/frameworks/categories" replace />}
              />
            ),
            children: [
              {
                index: true,
                lazy: async () => {
                  const module = await import('@/features/admin/framework/pages/CategoryPage')
                  return {
                    element: <module.CategoryPage />
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: 'subcategories',
        children: [
          {
            index: true,
            lazy: async () => {
              const module = await import('@/features/admin/framework/pages/SubcategoryListPage')
              return {
                element: <module.SubcategoryListPage />
              }
            }
          },
          {
            path: ':codigo',
            lazy: async () => {
              const module = await import('@/features/admin/framework/pages/SubcategoryPage')
              return {
                element: <module.SubcategoryPage />
              }
            }
          },
          {
            path: ':codigo/edit',
            element: (
              <ProtectedRoute
                requiredRoles={['Gerente', 'Administrador']}
                unauthorizedComponent={<Navigate to="/admin/frameworks/subcategories" replace />}
              />
            ),
            children: [
              {
                index: true,
                lazy: async () => {
                  const module = await import(
                    '@/features/admin/framework/pages/SubcategoryEditPage'
                  )
                  return {
                    element: <module.SubcategoryEditPage />
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  }
]
